import type {
  Assessment,
  Courses,
  Exercises,
  FunctionalTest,
  Lessons,
} from 'modules/dashboard/core/type';
import { Station } from 'modules/institution-info/core/type';
import type { Institution } from 'modules/institutions/core/type';
import type { Learner } from 'modules/learners/core/type';
import type { Trainer } from 'modules/trainers/core/type';

import type { LessonAssessmentType } from './enum';

export interface Classes {
  id: string;
  name: string;
  totalLearner: number;
  duration: string;
  isActive: boolean;
  description?: string;
  code: string;
  totalTrainer: number;
  totalLesson: number;
  trainers?: Trainer[];
  learners?: Learner[];
  lessons?: Lessons[];
  classCompletion: string;
  startDate?: string;
  endDate?: string;
  thumbnail?: string;
  institution?: Institution;
  station: Station;
  stationId?: string;
}

export interface ClassesFormRequest {
  name: string;
  description?: string;
  isActive?: boolean;
  isCompleted?: boolean;
  code?: string;
  thumbnail?: string;
  institution?: string;
}

export interface ClassesCreateCompProps {
  searchValue: string;
  onChangeSearchValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
  coursesData: Courses[];
  goToAddPage: () => void;
  handleSelectedCourse: (value: Courses) => void;
  selectedCourse: Courses;
  onDeleteSelectedCourse: () => void;
  disabledNextButton: boolean;
  name: string;
  description: string;
  handleChange: any;
  file: string;
  onChangeFiles: (values: File[]) => void;
  onDeleteThumbnail: () => void;
  isBiologicAdmin: boolean;
  institutions: {
    value: string;
    label: string;
  }[];
  onChangeInstitution: (value: any) => void;
  institutionId: string;
  handleGetWidthAndHeightThumbnail: (e: any) => void;
  onChangeSearchInstitution: (value: string) => void;
  searchSelect: string;
  stations: Station[];
  onChangeStation: (value: any) => void;
  selectedStation?: { value: string; label: string };
}

export interface ClassesAddCompProps {
  trainersData: Trainer[];
  handleAddTrainersToClass: () => void;
  searchValue: string;
  onChangeSearchValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
  columns: any[];
  trainerColumns: any[];
  selectedData: Trainer[];
  goBackToCreatePage: () => void;
  disabledButton: boolean;
  handleSubmit: () => void;
  hasMoreTrainer: boolean;
  handleLoadMoreTrainer: () => void;
}

export interface EventCalendar {
  id: string;
  title: string;
  start: string | Date;
  end: string | Date;
  type: string;
  classLessonId?: string;
  classScheduleId?: string;
  lessonType?: LessonAssessmentType;
}

export interface LessonsInClass {
  today: Lessons[];
  future: Lessons[];
  unscheduled: Lessons[];
  past: Lessons[];
  totalLearner: number;
  institution?: Institution;
}

export interface GroupInClass {
  index: number;
  id: string;
  class: Classes;
}

export interface LessonDetail {
  lesson: Lessons;
  result: LearnerResult[];
}

export interface LessonAndAssessmentResult {
  lessons: LessonResult[];
  assessments: AssessmentResult[];
  class: Classes;
  learner: Learner;
  lessonScore: number;
  assessmentScore: number;
}

export interface LessonResult {
  lesson: Lessons;
  items: Exercises[];
}

export interface AssessmentResult {
  assessment: Assessment;
  items: FunctionalTest[];
}

export interface LearnerResult {
  learner: Learner;
  items: Exercises[];
}

export interface AssessmentDetail {
  lesson: Assessment;
  result: LearnerResult[];
}

export interface LearnerMarkingAbsence {
  userId: string;
  name: string;
  avatar: string | null;
  isAbsent?: boolean;
}

export enum GamificationType {
  TRAINER,
  LEARNER,
}
